import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import BackButton from "../../shared/components/backButton";
import Layout from "../../shared/components/layout";

const PersonPickerList = styled.ul`
  padding: 0;
  list-style: none;
  margin: 0;
`;

const Input = styled.input`
  margin-right: 10px;
`;

const Disclaimer = styled.div`
  font-size: 16px;
`;

const ButtonContainer = styled.div`
  margin: 40px 0;
  font-family: gotham-500;
`;

function SelectTransferMember({ members }) {
  const { register, handleSubmit, errors } = useForm();
  const [selectedMemberId, setSelectedMemberId] = useState(null);

  const onNext = () => {};

  useEffect(() => {});

  return (
    <Layout
      banner={"Transfer Health Information"}
      header={"Whose data would you like to transfer?"}
    >
      <BackButton></BackButton>
      <form onSubmit={handleSubmit(onNext)}>
        <PersonPickerList>
          {members.map((member) => (
            <li key={member.enterpriseId}>
              <label
                className="checkbox-container"
                htmlFor={member.enterpriseId}
              >
                <span className="capitalize-text">
                  {member.firstName} {member.lastName}, ({member.role})
                </span>

                <Input
                  id={member.enterpriseId}
                  type="radio"
                  name="enterpriseId"
                  value={member.enterpriseId}
                  ref={register({ required: true })}
                  onChange={() => setSelectedMemberId(member.enterpriseId)}
                  className="cigna-checkbox"
                />
                <span className="radio"></span>
              </label>
            </li>
          ))}
        </PersonPickerList>

        <span className="validation-error-msg">
          {errors.enterpriseId && "Please select a member."}
        </span>

        <ButtonContainer>
          <button type="submit" className="btn btn-primary">
            Next
          </button>
        </ButtonContainer>
      </form>

      <Disclaimer>
        To start your transfer, you'll need to log in with your credentials from
        your previous insurance provider.
      </Disclaimer>
    </Layout>
  );
}

export default SelectTransferMember;
